import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import IntegrationTabs from "./integration-page/IntegrationTabs";
import useIntegrationData from "./integration-page/useIntegrationData";
import {
  navigateToIntegrationBuilderPostIntegrationInitialization,
  getCodeBlockProgressIntegrationPath,
} from "../../router/RouterUtils";
import { useHistory } from "react-router-dom";
import { IntegrationAvatar } from "../shared/MergeAvatars";
import { Integration } from "../../models/Entities";

type Props = {
  children: JSX.Element | JSX.Element[];
  integration: Integration;
};

const IntegrationPageWrapper = ({ integration, children }: Props) => {
  const { integrationName } = useIntegrationData(integration.id);
  const history = useHistory();

  return (
    <>
      <div className="flex flex-col mt-10">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center space-x-4">
            <IntegrationAvatar integration={integration} />
            <Text variant="h2">{integrationName}</Text>
          </div>
          <div className="flex items-center gap-2">
            <Button
              size="md"
              variant={ButtonVariant.SecondaryGray}
              onClick={() => history.push(getCodeBlockProgressIntegrationPath(integration.id))}
            >
              Code block progress
            </Button>
            <Button
              size="md"
              onClick={() =>
                navigateToIntegrationBuilderPostIntegrationInitialization(
                  history,
                  integration.id,
                  true
                )
              }
            >
              Edit integration
            </Button>
          </div>
        </div>

        <IntegrationTabs integrationID={integration.id} />
        {children}
      </div>
    </>
  );
};

export default IntegrationPageWrapper;
